<template>
    <div class="Container column">
        <div class="Card row flex-center">
            <QCard
                class="MeetingBox col-6"
                flat
            >
                <QCardSection class="text-weight-bold text-center text-h6">
                    {{ App.numberLocationFormat(improvementFigures.redBecomeGreenAbsolute, true) }}
                    {{ $t('booster.improvement.improvementFigures.cases') }}
                    <span class="MeetingPercent">{{ App.numberLocationFormat(improvementFigures.redBecomeGreenPercentage, true) }}%</span>
                </QCardSection>
            </QCard>
            <div class="col-6 q-pl-md text-h5">
                <strong class="RedColor">
                    {{ $t('booster.improvement.improvementFigures.red') }}
                </strong>
                <strong>
                    {{ $t('booster.improvement.improvementFigures.become') }}
                </strong>
                <strong class="GreenColor">
                    {{ $t('booster.improvement.improvementFigures.green') }}
                </strong>
            </div>
        </div>
        <div class="Card row flex-center">
            <QCard
                class="UnderRiskBox col-6"
                flat
            >
                <QCardSection class="text-weight-bold text-center text-h6">
                    {{ improvementFigures.improvedDurationAbsolute }}
                    <span class="UnderRiskPercent">{{ App.numberLocationFormat(improvementFigures.decreaseDurationPercentage, true) }}%</span>
                </QCardSection>
            </QCard>
            <div class="col-6 q-pl-md text-h5">
                <strong class="GreenColor">
                    {{ $t('booster.improvement.improvementFigures.decrease') }}
                </strong>
                <strong>
                    {{ $t('booster.improvement.improvementFigures.overallDuration') }}
                </strong>
            </div>
        </div>
        <div class="Card row flex-center">
            <QCard
                class="ExceedingBox col-6"
                flat
            >
                <QCardSection class="text-weight-bold text-center text-h6">
                    {{ App.numberLocationFormat(improvementFigures.improvedCost, false, true) }}
                    <span class="ExceedingPercent">{{ App.numberLocationFormat(improvementFigures.decreaseCostPercentage, true) }}%</span>
                </QCardSection>
            </QCard>
            <div class="col-6 q-pl-md text-h5">
                <strong class="GreenColor">
                    {{ $t('booster.improvement.improvementFigures.decrease') }}
                </strong>
                <strong>
                    {{ $t('booster.improvement.improvementFigures.overallCosts') }}
                </strong>
            </div>
        </div>
        <q-inner-loading
            :showing="!improvementFigures || !Object.keys(improvementFigures).length"
        />
    </div>
</template>
<script>
import VueTypes from 'vue-types'

export default {
    name: 'ImprovementFigures',
    inject: ['App'],
    props: {
        improvementFigures: VueTypes.object,
    },
    data() {
        return {
        }
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        numFormatter(num) {
            if (num > 999 && num < 1000000) {
                return `${(num / 1000).toFixed(1) }K`
            } if (num >= 1000000) {
                return `${(num / 1000000).toFixed(1) }M`
            }
            return num
        },
    },
}
</script>
<style scoped lang="scss">
    .Container {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
    }
    .Card {
        width: 100%;
        margin-bottom: 10px;
    }
    .q-card__section--vert {
        height: 90%;
    }
    .MeetingBox, .UnderRiskBox, .ExceedingBox {
        border: 3px solid $primary;
    }
    .MeetingPercent, .UnderRiskPercent,  .ExceedingPercent {
        color: $primary;
    }
    .GreenColor {
        color: #00C383;
    }
    .RedColor {
        color: #fc7474;
    }
</style>
